module.exports = __webpack_public_path__ + "media/icons/home-arrow-adb2cdf8.svg";